import axiosInstance from "../../apiAxios/axiosInstance";

export const SupplierList = async (payload) => {
  const response = await axiosInstance.post("/admin/supplier-list", payload);
  return response.data;
};
export const ActiveSupplierList = async(payload) => {
   const resposne=await axiosInstance.post("/admin/active-supplier-list",payload);
   return resposne.data
};
export const AddSupplier = async (payload) => {
  const response = await axiosInstance.post("/admin/supplier-store", payload);
  return response.data;
};

export const ViewSupplier = async (payload) => {
  const response = await axiosInstance.post("/admin/supplier-show", payload);
  return response.data;
};

export const UpdateSupplier = async (payload) => {
  const response = await axiosInstance.post("/admin/supplier-update", payload);
  return response.data;
};

export const DeleteSupplier = async (payload) => {
  const response = await axiosInstance.post("/admin/supplier-delete", payload);
  return response.data;
};

export const SupplierChangeStatus = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/supplier-status-update",
    payload
  );
  return response.data;
};